// extracted by mini-css-extract-plugin
export default {"formatLessonWrapper":"FormatLesson_formatLessonWrapper__OUmIZ"};